export enum TipoAgendamento{
   Consulta,
   Compromisso,
   Coletivo
}
